export default __webpack_public_path__ + "images/check.v-8db0b7b8fb58a6875e582a0f5e6224f5.svg";